import { api } from '../api';

/** Datos del promotor en el maestro de Binary (`COM_PROMOTORES`). */
export interface PromotorBinary {
  username: string;
  apellidoNombre: string;
  legajo: string | null;
  tipo: string | null;
  /** 'A' = activo. Viene crudo de Binary. */
  estado: string | null;
  sector: string | null;
  supervision: string | null;
}

/** Por qué puede (o no) cargar. Son las claves del server (`puedeSubirPadron`). */
export type MotivoCarga =
  | 'permiso-rol'
  | 'promotor-binary'
  | 'permiso-manual'
  | 'sin-verificar-binary'
  | 'denegado-manual'
  | 'no-es-promotor'
  | 'sin-promotor-cargado'
  /** Tiene permiso, pero la organización no tiene ningún plan en venta. */
  | 'sin-plan';

/**
 * Un plan que la organización ofrece para cargar un padrón. La identidad es
 * código + sucursal: el mismo plan puede estar en venta en varias sucursales
 * del empleador y cada una es una opción distinta.
 */
export interface PlanDelPerfil {
  codigo: string;
  nombre: string;
  /** Vacía si el plan no tiene sucursal configurada. */
  sucursalId: string;
  esBase: boolean;
}

/** Una empresa del usuario y si Binary lo tiene como promotor vigente de ella. */
export interface EmpresaDelPerfil {
  empresaId: string;
  nombre: string;
  oracleEmplId: number | null;
  esPromotor: boolean;
  /** Por qué Binary no lo tiene como promotor. Vacío cuando sí. */
  motivo?: string;
  /**
   * Si puede subir padrones de esta organización: la MISMA decisión que toma el
   * server al subir. No es `esPromotor`: la organización y los admins Medicus
   * cargan por rol sin figurar en Binary.
   */
  puedeCargar: boolean;
  motivoCarga: MotivoCarga;
  /** Texto para mostrar cuando NO puede. */
  detalleCarga?: string;
  planes: PlanDelPerfil[];
  /** Plan con el que entra el padrón si no se elige otro. */
  planCodigoSugerido: string;
  /** Sucursal de ese plan sugerido (vacía si no tiene). */
  sucursalIdSugerida: string;
  /** Promotor que se va a estampar en las altas. */
  promotorUsername: string;
}

export interface PerfilPromotor {
  binaryUsername: string;
  promotor: PromotorBinary | null;
  empresas: EmpresaDelPerfil[];
  /** Presente SOLO si no se pudo consultar Binary (Oracle caído, sin VPN…). */
  diagnostico?: string;
}

/**
 * Perfil del usuario logueado. La habilitación por empresa es el permiso del
 * rol (la organización carga las suyas, los admins Medicus todas) más lo que
 * Binary SUMA en vivo (`SA_PROMOTORES_EMPLEADORES`).
 */
export async function getMiPerfil(): Promise<PerfilPromotor> {
  const { data } = await api.get<PerfilPromotor>('/perfil');
  return data;
}
